import { jsx as _jsx } from "react/jsx-runtime";
import './StickyFooter.scss';
export const StickyFooter = ({ children }) => {
    return _jsx("div", { className: 'sg-stickyFooter', children: children });
};
//# sourceMappingURL=StickyFooter.js.map